import React, { Component } from "react";
import { connect } from "react-redux";

import SummaryMilestones from "../components/summaryMilestones/summaryMilestones";
import Documents from "../documents/documents";
import Actions from "../components/actions/actions";
import Updates from "../components/updates/updates";
import Team from "../components/team/team";
import * as summaryMilestonesActions from "../components/summaryMilestones/summaryMilestonesActions";
import * as documentsActions from "../documents/documentsActions";
import * as actionsActions from "../components/actions/actionsActions";
import * as actionActions from "../components/action/actionActions";
import * as updatesActions from "../components/updates/updatesActions";
import * as teamActions from "../components/team/teamActions";
import * as routes from "../shared/routes";
import Loading from "../components/loading/loading";
import analytics from "../shared/analytics";
import Error from "../components/error/error";

class CaseSummary extends Component {
  componentDidMount() {
    analytics.pageView();
    this.props.onGetActions(
      this.props.actions.loading,
      this.props.id,
      this.props.udModuleUid,
      this.props.token
    );

    this.props.onGetSummaryMilestones(
      this.props.summaryMilestones.loading,
      this.props.id,
      this.props.udModuleUid,
      this.props.masterProcessId,
      this.props.token
    );

    this.props.onGetUpdates(
      this.props.updates.loading,
      this.props.id,
      this.props.udModuleUid,
      this.props.token
    );

    this.props.onGetDocuments(
      this.props.documents.loading,
      this.props.id,
      this.props.token
    );

    this.props.onGetTeam(
      this.props.team.loading,
      this.props.id,
      this.props.token
    );
  }

  shouldComponentUpdate(nextProps) {
    return (
      !nextProps.summaryMilestones.loading &&
      !nextProps.team.loading &&
      !nextProps.documents.loading &&
      !nextProps.updates.loading &&
      !nextProps.actions.loading
    );
  }

  actionClickHandler = (actionId, actionDescription, projectId, screenId) => {
    this.props.onSetAction(actionId, actionDescription, projectId, screenId);
    this.props.history.push(routes.clientDataCollect);
  };

  render() {
    if (this.props.actions.error && !this.props.actions.forbidden) {
      return Error(this.props.actions.error);
    }
    if (this.props.summaryMilestones.error && !this.props.summaryMilestones.forbidden) {
      return Error(this.props.summaryMilestones.error)
    }
    if (this.props.updates.error && !this.props.updates.forbidden) {
      return Error(this.props.updates.error)
    }
    if (this.props.documents.error && !this.props.documents.forbidden) {
      return Error(this.props.documents.error)
    }
    if (this.props.team.error && !this.props.team.forbidden) {
      return Error(this.props.team.error)
    }

    let content = null;
    if (
      this.props.updates.completedActions === null ||
      this.props.summaryMilestones.milestones === null ||
      this.props.actions.actions === null ||
      this.props.team.team === null ||
      this.props.documents.documents === null
    ) {
      content = Loading();
    }
    else {
      let updatesCount = this.props.updates.completedActions !== null ? this.props.updates.completedActions.length : null;
      let notCompletedActionCount = this.props.actions.actions.filter(
        a => a.status !== 2
      ).length;
      let actionsVisible = !this.props.actions.forbidden;
      let updatesVisible = !this.props.updates.forbidden;
      let teamVisible = !this.props.team.forbidden;
      let documentsVisible = !this.props.documents.forbidden;
      let milestonesVisible = !this.props.summaryMilestones.forbidden;

      const widgets = [
        { widget: "actions", isVisible: actionsVisible },
        { widget: "updates", isVisible: updatesVisible },
        { widget: "team", isVisible: teamVisible },
        { widget: "documents", isVisible: documentsVisible }
      ].filter(x => x.isVisible);

      let widgetsForRows = [];
      while (widgets[0]) {
        widgetsForRows.push(widgets.splice(0, 2));
      }

      let milestoneButton = milestonesVisible ? (
        <mosaic-button color="light" card="milestones" pill >
          Progress
        </mosaic-button>
      ) : null;

      let actionsButton = null;
      if (actionsVisible) {
        let badgeValue = notCompletedActionCount === 0 ? null : notCompletedActionCount;
        actionsButton = (
          <mosaic-button color="light" card="actions" pill>
            Actions
              <mosaic-badge color="danger" pill>
              {badgeValue}
            </mosaic-badge>
          </mosaic-button>
        );
      }

      let updatesButton = null;
      if (updatesVisible) {
        if (updatesCount !== 0) {
          updatesButton = (
            <mosaic-button color="light" card="updates" pill>
              Updates
              <mosaic-badge color="info" pill>
                {updatesCount}
              </mosaic-badge>
            </mosaic-button>
          );
        } else {
          updatesButton = (
            <mosaic-button color="light" card="updates" pill>
              {" "}
              Updates
            </mosaic-button>
          );
        }
      }

      let teamButton = teamVisible ? (
        <mosaic-button color="light" card="team" pill>
          Team
        </mosaic-button>
      ) : null;

      let documentsButton = documentsVisible ? (
        <mosaic-button color="light" card="documents" pill>
          Documents
        </mosaic-button>
      ) : null;

      let milestonesRow = null;
      if (milestonesVisible) {
        milestonesRow = (
          <mosaic-row>
            <SummaryMilestones
              cardName="milestones"
              summaryMilestones={this.props.summaryMilestones}
            />
          </mosaic-row>
        );
      }

      let rows = widgetsForRows.map((widgets, i) => {
        return (
          <mosiac-row key={i} class="row">
            {widgets.map((widget, index) => {
              switch (widget.widget) {
                case "actions":
                  return (
                    <Actions
                      key={index}
                      cardName="actions"
                      actions={this.props.actions}
                      notCompletedActionCount={notCompletedActionCount}
                      onClick={(
                        actionId,
                        actionDescription,
                        projectId,
                        screenId
                      ) =>
                        this.actionClickHandler(
                          actionId,
                          actionDescription,
                          projectId,
                          screenId
                        )
                      }
                    />
                  );

                case "updates":
                  return (
                    <Updates
                      key={index}
                      cardName="updates"
                      updates={this.props.updates}
                    />
                  );

                case "team":
                  return (
                    <Team
                      key={index}
                      cardName="team"
                      team={this.props.team}
                    />
                  );

                case "documents":
                  return (
                    <Documents
                      key={index}
                      cardName="documents"
                      documents={this.props.documents}
                      token={this.props.token}
                    />
                  );
                default:
                  return null;
              }
            })}
          </mosiac-row>
        );
      });

      content = (
        <mosaic-card-toggle-layout>
          <mosaic-nav>
            {milestoneButton}
            {actionsButton}
            {updatesButton}
            {teamButton}
            {documentsButton}
          </mosaic-nav>
          {milestonesRow}
          {rows}
        </mosaic-card-toggle-layout>
      );
    }

    return (
      <mosaic-content-container>
        <mosaic-main-container fluid>

          <mosaic-page-header title={this.props.matterReference + ' - ' + this.props.matterDescription} overflow />
          <div>
            {content}
          </div>
        </mosaic-main-container>
      </mosaic-content-container>

    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetSummaryMilestones: (
      loading,
      id,
      udModuleUid,
      masterProcessId,
      token
    ) =>
      dispatch(
        summaryMilestonesActions.getSummaryMilestones(
          loading,
          id,
          udModuleUid,
          masterProcessId,
          token
        )
      ),

    onGetActions: (loading, id, udModuleUid, token) =>
      dispatch(actionsActions.getActions(loading, id, udModuleUid, token)),

    onGetUpdates: (loading, id, udModuleUid, token) =>
      dispatch(updatesActions.getUpdates(loading, id, udModuleUid, token)),

    onGetDocuments: (loading, id, token) =>
      dispatch(documentsActions.getDocuments(loading, id, token)),

    onGetTeam: (loading, id, token) =>
      dispatch(teamActions.getTeam(loading, id, token)),

    onSetAction: (actionId, actionDescription, projectId, screenId) =>
      dispatch(
        actionActions.setAction(
          actionId,
          actionDescription,
          projectId,
          screenId
        )
      )
  };
};

const mapStateToProps = state => ({
  token: state.login.token,
  matterDescription: state.matter.description,
  matterReference: state.matter.reference,
  id: state.matter.id,
  udModuleUid: state.matter.udModuleUid,
  masterProcessId: state.matter.masterProcessId,
  summaryMilestones: state.summaryMilestones,
  actions: state.actions,
  updates: state.updates,
  documents: state.documents,
  team: state.team
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseSummary);
